import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

type Props = {
  to: string;
  className?: string;
};

/** Atalho para quem já é constelador e chega pela home ou pelo link do influencer. */
export function ConsteladorEntryCard({ to, className = "" }: Props) {
  const classes = `group relative mb-5 block overflow-hidden rounded-[2rem] border border-white/80 bg-gradient-to-br from-white via-white to-[#F6EEF3] p-5 text-left shadow-[0_18px_40px_rgba(58,88,89,0.10)] ring-1 ring-[#A56096]/15 transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_44px_rgba(165,96,150,0.16)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#A56096] sm:p-6 ${className}`;
  const body = (
    <>
      <span
        className="pointer-events-none absolute -right-10 -top-12 h-36 w-36 rounded-full bg-[#A56096]/15 blur-2xl"
        aria-hidden
      />
      <span
        className="pointer-events-none absolute -bottom-10 left-6 h-24 w-24 rounded-full bg-[#3A5859]/10 blur-2xl"
        aria-hidden
      />
      <span className="relative flex flex-col items-start gap-4">
        <span>
          <span className="inline-flex rounded-full bg-[#A56096]/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#A56096]">
            Para quem conduz
          </span>
          <span className="mt-3 block text-xl font-extrabold leading-snug tracking-tight text-[#3A5859]">
            Você é Constelador(a)?
          </span>
          <span className="mt-1 block text-sm leading-relaxed text-[#496566]">
            Compre horas avulsas ou conheça os nossos planos
          </span>
        </span>
        <span className="inline-flex items-center gap-2 rounded-full bg-[#A56096] px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#A56096]/25 transition group-hover:bg-[#945586]">
          Clique aqui
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden />
        </span>
      </span>
    </>
  );

  if (to.startsWith("#")) {
    return (
      <a href={to} className={classes}>
        {body}
      </a>
    );
  }

  return (
    <Link to={to} className={classes}>
      {body}
    </Link>
  );
}
